export default [
  {
    path: '/products',
    name: 'PageProductsList',
    meta: { title: 'products.listTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/products'),
  },
  {
    path: '/products/create',
    name: 'PageProductsCreate',
    meta: { title: 'products.createFormTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/products/create'),
  },
  {
    path: '/products/:id/edit',
    name: 'PageProductsEdit',
    meta: { title: 'products.editFormTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/products/id/edit'),
  },
]
